import defaultFavicon from "/defaultfavicon.png";

export const defaultFaviconUrl = defaultFavicon;
